<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.t-sort(@click="handleClick")
    +e.IMG.img(
      :class="{'is-decrise' : !decrise}"
      src="static/img/arrow.svg"
      v-if="active"
    )
    +e.IMG.img(
      :class="{'is-decrise' : !decrise}"
      src="static/img/arrow-non-active.svg"
      v-else
    )
</template>

<script>
export default {
  name: 't-sort',

  props: {
    decrise: {
      type: Boolean,
    },

    active: {
      type: Boolean,
    },
  },

  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.t-sort {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 6px auto;

  &__img {
    width: 12px;
    height: 12px;
    transition: transform 0.3s;

    &.is-decrise {
      transform: rotate(180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TSort/TSort.vue